import { CounterView } from './CounterView';
import type { CounterConfig } from './CounterView';
import type { AppStateController } from '../../../../app/state/AppStateController';
import { CoinCounterLayout } from '../../../../../layouts/common/CoinCounterLayout';
import { soundManager } from '../../../../app/SoundManager';

const coinsCounterConfig: CounterConfig = {
  initListener: (state, instance) => {
    instance.updateAmount(state.getCoins());
    state.subscriptions.onChange(
      ['coins'],
      () => {
        (instance as CoinCounterView).updateAmount(state.getCoins(), true);
      },
      instance,
    );
    instance.on('destroyed', () => {
      state.subscriptions.removeAllSubscriptions(instance);
    });
  },
};

export class CoinCounterView extends CounterView {
  constructor(state: AppStateController | null, iapAvailable: boolean) {
    super(coinsCounterConfig, new CoinCounterLayout(), state);

    if (!iapAvailable) {
      this.counterLayout?.plusButton?.props({
        visible: false,
      });
    }
  }

  public updateAmount(amount: number, animate = false): this {
    if (this.destroyed || !this.updateEnabled) return this;

    const { counterText } = this.counterLayout;

    counterText.removeTweens();

    if (!animate) {
      return super.updateAmount(amount);
    }

    const currentValue = parseInt(counterText.text, 10);

    counterText.tweenNumericTextValue({ from: currentValue, to: amount, roundMethod: Math.round }, 600, 'expOut', true);

    if (amount > currentValue) {
      soundManager.play('Gameplay_Coin_Reward');
    }

    return this;
  }
}
